export const TWO_YEARS_IN_MONTHS_AS_NUMBER = 24;

export const TWO_YEARS_IN_MONTHS_AS_STRING =
  TWO_YEARS_IN_MONTHS_AS_NUMBER.toString();
